export default __webpack_public_path__ + "static/media/b6.8688cfd4.png";